"use client";

import { useEffect, useMemo } from "react";
import { useAppContext } from "./appContext";

export default function PageWrapper({
  translations,
  children,
}: {
  translations: null | { language: string; slug: { current: string } }[];
  children: React.ReactNode;
}) {
  const { handleTranslations } = useAppContext();

  // Use useMemo to compute `en` and `cs` slugs only once when translations change
  const { en, cs } = useMemo(() => {
    const enTranslation =
      translations?.find((t) => t.language === "en")?.slug?.current ?? "";
    const csTranslation =
      translations?.find((t) => t.language === "cs")?.slug?.current ?? "";
    return { en: enTranslation, cs: csTranslation };
  }, [translations]);

  // Use useEffect to call handleTranslations when `en` or `cs` values change
  useEffect(() => {
    if (handleTranslations && (en || cs)) {
      handleTranslations(en, cs);
    }
  }, [en, cs, handleTranslations]);

  return <>{children}</>;
}
